const detectSticky = {
  stickyElements: document.querySelectorAll(
    '.jsSticky',
  ) as NodeListOf<HTMLElement>,

  init() {
    this.setScroll();
  },

  checkSticky() {
    this.stickyElements.forEach((item) => {
      const isSticky = window.scrollY > 370;

      if (isSticky) {
        item.classList.add('activeScrolling');
      } else {
        item.classList.remove('activeScrolling');
      }
    });
  },

  setScroll() {
    window.addEventListener('scroll', () => {
      this.checkSticky();
    });
  },
};

export default detectSticky;
